import { Card, CardContent } from '@/shared/ui/card';
import { Label } from '@/shared/ui/label';
import { STAKEHOLDER_ICONS } from '../constants';
import type { StakeholderType } from '../types';

interface StakeholderStepProps {
  types: StakeholderType[];
  value: number | null;
  onChange: (id: number) => void;
  isLoading?: boolean;
}

export function StakeholderStep({ types, value, onChange, isLoading }: StakeholderStepProps) {
  if (isLoading) {
    return (
      <div className="space-y-4">
        <Label className="text-base font-medium">Select the stakeholder category for this contact</Label>
        <p className="text-sm text-muted-foreground">Loading types…</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <Label className="text-base font-medium">Select the stakeholder category for this contact</Label>
      <div className="grid gap-2 sm:grid-cols-2">
        {types.map((st) => (
          <Card
            key={st.id}
            className={`cursor-pointer transition-colors hover:border-primary ${
              value === st.id ? 'border-primary bg-primary/5' : ''
            }`}
            onClick={() => onChange(st.id)}
          >
            <CardContent className="flex items-center gap-3 p-4">
              <span className="text-2xl" aria-hidden>
                {STAKEHOLDER_ICONS[st.slug] ?? '•'}
              </span>
              <span className="font-medium">{st.label}</span>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
